import { render } from "./TYargu.vue?vue&type=template&id=56caaf0f&scoped=true"
import script from "./TYargu.vue?vue&type=script&lang=js"
export * from "./TYargu.vue?vue&type=script&lang=js"

import "./TYargu.vue?vue&type=style&index=0&id=56caaf0f&lang=scss&scoped=true"
import "./TYargu.vue?vue&type=style&index=1&id=56caaf0f&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56caaf0f"]])

export default __exports__